/**
 * Normalize permission lists for stable, order-independent comparison.
 * @param {string|string[]|undefined|null} permissions
 * @returns {string[]}
 */
export function normalizePermissions(permissions) {
  if (typeof permissions === 'string') {
    const trimmed = permissions.trim();
    return trimmed ? [trimmed] : [];
  }
  if (!Array.isArray(permissions)) return [];

  const seen = new Set();
  const normalized = [];
  for (const entry of permissions) {
    if (typeof entry !== 'string') continue;
    const key = entry.trim();
    if (!key || seen.has(key)) continue;
    seen.add(key);
    normalized.push(key);
  }
  return normalized.sort((a, b) => a.localeCompare(b));
}

/** Stable key for exact permission-set matching. */
export function permissionSetKey(permissions) {
  return JSON.stringify(normalizePermissions(permissions));
}

/** True when both lists represent the same permission combination. */
export function permissionSetsEqual(a, b) {
  return permissionSetKey(a) === permissionSetKey(b);
}
